// Recobro plan tiers. Kept in a single file so backend & frontend stay in sync.
// If the backend adds a new plan or changes limits, update here too.

export const PLAN_LIMITS = {
  Básico: 30,
  Pro: 150,
  Enterprise: 500,
};

export const PLAN_OPTIONS = ["Básico", "Pro", "Enterprise"];

// Features gated per plan (nav + route access).
export const PLAN_FEATURES = {
  Básico: { cotizaciones: false, comprobantes: false },
  Pro: { cotizaciones: true, comprobantes: true },
  Enterprise: { cotizaciones: true, comprobantes: true },
};

export function limitForPlan(plan) {
  return PLAN_LIMITS[plan] ?? 30;
}

export function planCan(plan, feature) {
  const conf = PLAN_FEATURES[plan] || PLAN_FEATURES.Básico;
  return !!conf[feature];
}
